import React from "react";
import { Button, Container } from "react-bootstrap";
import { MdLogin } from "react-icons/md";
import { useSelector } from "react-redux";
import { Route, useNavigate } from "react-router-dom";

const PrivateRoutesSuper = ({ children, ...rest }) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const profileData = useSelector((state) => state.auth.myProfile);
  const navigate = useNavigate();
  console.log(profileData);
  return isLoggedIn && profileData?.user?.is_superuser ? (
    children
  ) : !isLoggedIn || profileData?.user?.is_superuser === false ? (
    <>
      <Container className="mainContent text-center">
        <MdLogin size="50px" />
        <h1 className="my-3">Access Restricted</h1>
        <p>You need to login as Super Admin to access this content. </p>
        <Button
          onClick={() => navigate("?action=login")}
        >
          Back to Home
        </Button>
      </Container>
    </>
  ) : (
    ""
  );
};

export default PrivateRoutesSuper;
